import React, { useEffect, useState } from 'react';
import * as msal from '@azure/msal-browser';
import Loader from '../../../components/Loader/Loader';
import '../TruNorthDashboard/TruNorthDashboard.less';
import { formatUrl, handleZoom, removeCookie } from '../../../libs/helper/HelperFunctions';
import {
  IVisitedPagePayload,
  SectionType,
  TrafficAnalyticsActions,
} from '../../../libs/store/actions/WebAnalytics/TrafficAnalyticsActions';
import { useDispatch } from 'react-redux';
import { IProduct } from '../../../libs/models/cbo/EngagementModels';
import { IApplicationState, useAppSelector } from '../../../libs/store/reducers';
import { STORAGE_CONSTANTS, storage } from '../../../libs/services/LocalStorage';
import { CBOKeyAssets } from '../../CBOSidebar/CBOSidebarConstants';
import { getSASModernizerMSALConfig } from '../../CBOLogin/CBOLoginConstants';

interface IAssetProps {
  selectedAssetConfig?: IProduct;
  isEngagement?: boolean;
  selectedEnagagementName?: string;
  selectedEnagagementId?: string;
  selectedClientName?: string;
}

const SAS_MODERNIZER_ASSET_NAME = CBOKeyAssets.sasModernizer;

const SASModernizerDashboard = ({
  isEngagement,
  selectedAssetConfig,
  selectedEnagagementName,
  selectedEnagagementId,
  selectedClientName,
}: IAssetProps) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState<boolean>();

  const dispatcher = {
    postPageVisited: (data: IVisitedPagePayload) =>
      dispatch(TrafficAnalyticsActions.postVisitedPageStart(data)),
  };

  const { selectedClientId, keyAssetlistDefault } = useAppSelector((state: IApplicationState) => ({
    selectedClientId: state.cboViewSummary.selectedClientId,
    keyAssetlistDefault: state.engagement.KeyAssetDefaultList,
  }));

  const selectedAssetConfigDefault = keyAssetlistDefault?.find(
    (keyAsset) => keyAsset.product?.toLowerCase() === selectedAssetConfig?.product?.toLowerCase(),
  );

  const authenticateSASModernizer = async () => {
    const msalInstance = new msal.PublicClientApplication(getSASModernizerMSALConfig());
    storage?.removeSessionItem(STORAGE_CONSTANTS.msalInteractionStatus);
    removeCookie(STORAGE_CONSTANTS.msalInteractionStatus);
    await msalInstance.initialize();
    msalInstance.loginRedirect();
  };

  useEffect(() => {
    handleZoom('assess-iframe');
    dispatcher.postPageVisited({
      sectionType: isEngagement ? SectionType.ENG_ASSET : SectionType.PURSUIT_ASSET,
      assetName: SAS_MODERNIZER_ASSET_NAME,
      name: selectedEnagagementName,
      id: selectedEnagagementId,
      clientId: selectedClientId,
      clientName: selectedClientName,
    });

    const sasModernizerAuthenticated: any = isEngagement
      ? storage.getItemSession(STORAGE_CONSTANTS.sasModernizerEngAuthenticated)
      : storage.getItemSession(STORAGE_CONSTANTS.sasModernizerAuthenticated);

    if (sasModernizerAuthenticated === 'true') {
      setAuthenticated(true);
    } else {
      setAuthenticated(false);
      storage.setItem(STORAGE_CONSTANTS.authOriginatorUrl, window.location.pathname);
      authenticateSASModernizer();
    }

    return () => {
      storage?.removeSessionItem(STORAGE_CONSTANTS.sasModernizerAuthenticated);
      dispatcher.postPageVisited({
        sectionType: isEngagement ? SectionType.ENG_ASSET : SectionType.PURSUIT_ASSET,
        assetName: SAS_MODERNIZER_ASSET_NAME,
        name: selectedEnagagementName,
        id: selectedEnagagementId,
        clientId: selectedClientId,
        clientName: selectedClientName,
      });
    };
  }, []);

  const getIframeUrl = (instanceUrl?: string) => {
    return `${formatUrl(instanceUrl ?? '')}`;
  };

  return (
    <div className="trunorth-dashboard-wrapper">
      {authenticated && (
        <Loader loaderName="Authorizing..." loading={isLoading}>
          <iframe
            id="sas-modernizer"
            className="assess-iframe"
            title={SAS_MODERNIZER_ASSET_NAME}
            src={
              isEngagement
                ? getIframeUrl(selectedAssetConfig?.instanceUrl)
                : selectedAssetConfig?.configDone
                  ? getIframeUrl(selectedAssetConfig?.instanceUrl)
                  : getIframeUrl(selectedAssetConfigDefault?.instanceUrl)
            }
            onLoad={() => {
              setIsLoading(false);
              handleZoom('assess-iframe');
            }}
          />
        </Loader>
      )}
    </div>
  );
};

export default SASModernizerDashboard;
